import { render } from "./MedigapPlan.vue?vue&type=template&id=4ddeb598"
import script from "./MedigapPlan.vue?vue&type=script&lang=js"
export * from "./MedigapPlan.vue?vue&type=script&lang=js"

import "./MedigapPlan.vue?vue&type=style&index=0&id=4ddeb598&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__